/** Formattatori condivisi dalle pagine. Nessuna logica, solo presentazione. */

export function dataIt(valore) {
  if (!valore) return "—";
  const d = new Date(String(valore).slice(0, 10) + "T00:00:00Z");
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("it-IT", { timeZone: "UTC" });
}

/** Le colonne data di Dataverse sono DateOnly: per un <input type="date"> serve `YYYY-MM-DD`. */
export function dataInput(valore) {
  return valore ? String(valore).slice(0, 10) : "";
}

export function euro(valore) {
  if (valore == null || valore === "") return "—";
  const n = Number(valore);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });
}

/**
 * Giorni da oggi alla data, in UTC sulla sola parte di giorno: negativo se passata.
 * `null` se la data manca — che e' il caso normale, non un errore: la data di disdetta esiste
 * solo dove esiste un preavviso.
 */
export function giorniA(valore) {
  if (!valore) return null;
  const d = new Date(String(valore).slice(0, 10) + "T00:00:00Z");
  if (Number.isNaN(d.getTime())) return null;
  const oggi = new Date();
  const oggiUtc = Date.UTC(
    oggi.getUTCFullYear(),
    oggi.getUTCMonth(),
    oggi.getUTCDate(),
  );
  return Math.round((d.getTime() - oggiUtc) / 86400000);
}

export function etichetta(mappa, valore, vuoto = "—") {
  if (valore == null || valore === "") return vuoto;
  return mappa[valore] ?? `(${valore})`;
}
